import * as React from 'react'
import { Form, Field, InjectedFormProps } from 'redux-form'
import { vRequired } from 'components/Input/Input.validations'
import Button from 'components/Button'
import { dispatchToProps } from './ContactTriggerFlow.container'
import { IContactClient } from 'features/Contacts/types'
import cn from 'classnames'
import * as sMarg from 'styles/modules/margins.scss'
import * as sLay from 'styles/modules/layout.scss'
import SelectPretty from 'components/Input/SelectPretty'
import * as sText from 'components/Text/Text.scss'
import LoadingOverlay from 'components/Loading/LoadingOverlay'

export interface IContactTriggerFlowProps extends InjectedFormProps<any> {
  contact: IContactClient
  listTriggers: typeof dispatchToProps['listTriggers']
  subscribeContactToFlow: typeof dispatchToProps['subscribeContactToFlow']
  onAfterSubmit: () => undefined
  triggers: any[]
  loading: boolean
}

export class ContactTriggerFlowComponent extends React.Component<IContactTriggerFlowProps> {
  componentWillMount() {
    const { listTriggers } = this.props
    listTriggers()
  }
  render() {
    const {
      submitting,
      handleSubmit,
      triggers,
      loading,
      subscribeContactToFlow,
      contact,
      onAfterSubmit,
    } = this.props

    const options = triggers.map(trigger => ({
      name: `${trigger.flowName} (${trigger.triggerName || trigger.triggerId})`,
      value: trigger.triggerId,
    }))

    const submit = (data: any) => {
      const trigger = triggers.find(trigger => trigger.triggerId === data.triggerId)
      return subscribeContactToFlow({
        contactId: contact.id,
        triggerId: trigger.triggerId,
        flowId: trigger.flowId,
      }).then(onAfterSubmit)
    }

    return (
      <Form onSubmit={handleSubmit(submit)}>
        <div className={cn(sText.descrip4, sText.center, sMarg.mb30)}>
          Select the flow and trigger you want to subscribe this contact to. Your flow must be
          published and must have a{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://help.thinkpickle.com.au/flows/triggers/contact-subscribed"
          >
            'Contact Subscribed'
          </a>{' '}
          trigger.
        </div>
        <Field
          label="Flow"
          component={SelectPretty}
          name="triggerId"
          options={options}
          validate={[vRequired]}
        />
        <br />
        <div className={cn(sLay['layout-column'], sLay['layout-align-center-center'], sMarg.mt30)}>
          <Button color="tertiary" loading={submitting} type="submit">
            Subscribe
          </Button>
        </div>
        {loading && triggers.length === 0 && <LoadingOverlay />}
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// src/features/Contacts/ContactTriggerFlow/ContactTriggerFlow.tsx